import { useLayoutEffect, useState } from 'react'

type Mode = 'min-width' | 'max-width'

export const useIsOnCustomSize = (sizeNumber = 960, mode: Mode = 'max-width') => {
  const [size, setSize] = useState(0)

  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  if (mode === 'max-width') {
    return size <= sizeNumber
  } else {
    return size >= sizeNumber
  }
}
